class TerminalKeyChecker {
    private static _keyCode(e: KeyboardEvent): string {
        return e.key;
    }

    /**
     * Alt + T tab생성
     * @param e
     * @return {boolean}
     */
    static isCreateTab(e: KeyboardEvent): boolean {
        return e.altKey && TerminalKeyChecker._keyCode(e) === "t";
    }

    /**
     * Alt + W tab제거
     * @param e
     * @return {boolean}
     */
    static isCloseTab(e: KeyboardEvent): boolean {
        return e.altKey && TerminalKeyChecker._keyCode(e) === "w";
    }

    /**
     * alt + 0 마지막 탭 선택
     * @param e
     * @return {boolean}
     */
    static isSelectLastTab(e: KeyboardEvent): boolean {
        return e.altKey && TerminalKeyChecker._keyCode(e) === "0";
    }


    /**
     * alt + 1 ~ 9 n번째 탭 선택
     * @param e
     * @return {boolean}
     */
    static isSelectTab(e: KeyboardEvent): boolean {
        const keyCode = TerminalKeyChecker._keyCode(e);

        return e.altKey && 1 <= Number(keyCode) && Number(keyCode) <= 10;
    }

    /**
     * Alt + PageUp 왼쪽으로 탭 옮기기
     * @param e
     * @return {boolean}
     */
    static isLeftTab(e: KeyboardEvent): boolean {
        return e.altKey && TerminalKeyChecker._keyCode(e) === 'PageUp'
    }

    /**
     * Alt + PageDown 오른쪽으로 탭 옮기기탭
     * @param e
     * @return {boolean}
     */
    static isRightTab(e: KeyboardEvent): boolean {
        return e.altKey && TerminalKeyChecker._keyCode(e) === 'PageDown'
    }

    /**
     *  Alt + H 단축키 도움말
     * @param e
     * @return {boolean}
     */
    static isHelp(e: KeyboardEvent): boolean {
        return e.altKey && TerminalKeyChecker._keyCode(e) === "h"
    }

    /**
     * 복사 Ctrl + Shift + c
     * @param e
     * @return {boolean}
     */
    static isCopy(e: KeyboardEvent): boolean {
        return e.ctrlKey && e.shiftKey && TerminalKeyChecker._keyCode(e) === "C"
    }

    /**
     * 검색 Ctrl + Shift + F
     * @param e
     * @return {boolean}
     */
    static isSearch(e: KeyboardEvent): boolean {
        return e.ctrlKey && e.shiftKey && TerminalKeyChecker._keyCode(e) === "F"
    }

}

export interface TerminalShortCutKeyHelperHandler {
    onCreateTab?(): void,

    onCloseTab?(): void,

    onHelp?(): void,

    onSelectLastTab?(): void,

    onSelectTab?(index: number): void,

    onLeftTab?(): void,

    onRightTab?(): void,

    onCopy?(): void,

    onSearchDialog?(): void,
}

export default class TerminalShortCutKeyHelper {
    private readonly _handler: TerminalShortCutKeyHelperHandler;

    constructor(handler?: TerminalShortCutKeyHelperHandler) {
        this._handler = handler || {};
    }

    keyup(e: KeyboardEvent) {
        if (TerminalKeyChecker.isCreateTab(e) && this._handler.onCreateTab) {
            e.preventDefault();
            this._handler.onCreateTab();
        } else if (TerminalKeyChecker.isCloseTab(e) && this._handler.onCloseTab) {
            e.preventDefault();
            this._handler.onCloseTab();
        } else if (TerminalKeyChecker.isHelp(e) && this._handler.onHelp) {
            e.preventDefault();
            this._handler.onHelp();
        } else if (TerminalKeyChecker.isSelectLastTab(e) && this._handler.onSelectLastTab) {
            e.preventDefault();
            this._handler.onSelectLastTab();
        } else if (TerminalKeyChecker.isSelectTab(e) && this._handler.onSelectTab) {
            e.preventDefault();
            const keyCode = parseInt(e.key, 10) - 1;
            this._handler.onSelectTab(keyCode);
        } else if (TerminalKeyChecker.isLeftTab(e) && this._handler.onLeftTab) {
            e.preventDefault();
            this._handler.onLeftTab();
        } else if (TerminalKeyChecker.isRightTab(e) && this._handler.onRightTab) {
            e.preventDefault();
            this._handler.onRightTab();
        } else if (TerminalKeyChecker.isSearch(e) && this._handler.onSearchDialog) {
            e.preventDefault();
            this._handler.onSearchDialog();
        } else if (TerminalKeyChecker.isCopy(e) && this._handler.onCopy) {
            e.preventDefault();
            this._handler.onCopy();
            return false;
        }
    }

    async keydown(e: KeyboardEvent) {
        if (TerminalKeyChecker.isCreateTab(e)) {
            e.preventDefault();
        } else if (TerminalKeyChecker.isCloseTab(e)) {
            e.preventDefault();
        } else if (TerminalKeyChecker.isHelp(e)) { // Alt + H
            e.preventDefault();
        } else if (TerminalKeyChecker.isLeftTab(e)) { // Alt + PageUp
            e.preventDefault();
        } else if (TerminalKeyChecker.isRightTab(e)) { // Alt + PageDown
            e.preventDefault();
        } else if (TerminalKeyChecker.isSearch(e)) {
            e.preventDefault();
        } else if (TerminalKeyChecker.isCopy(e)) {
            e.preventDefault();
            return false;
        }
    }

}